import styled from "@emotion/styled";
import bg from "../../../../assets/fondo-azul-degradado.webp";
import { tokens } from "@/shared/design-system/tokens";

export type ModalSize = "sm" | "md" | "lg";

const SIZE_WIDTHS: Record<ModalSize, number> = {
  sm: 446,
  md: 600,
  lg: 800,
};

export const ModalBox = styled.div<{
  styleBackground?: "normal" | "plane";
  $size?: ModalSize;
}>`
  width: ${({ $size }) => SIZE_WIDTHS[$size ?? "md"]}px;
  max-width: 100%;
  color: #fafafa;
  border-radius: 16px;
  background: ${props => props.styleBackground === "normal" ? `linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.1) 100%
    ),
    url(${bg}) lightgray 50% / cover no-repeat;` : tokens.colors.blue[900]};
  padding: 1.5rem;
  z-index: 10;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: visible;

  @media (max-width: ${tokens.breakpoints.md - 1}px) {
    padding: ${tokens.spacing.lg} ${tokens.spacing.md};
    border-radius: ${tokens.borderRadius.xl};
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 44px;
  height: 44px;
  padding: 10px;
  border: none;
  background: transparent;
  color: ${tokens.colors.basics[0]};
  cursor: pointer;
  z-index: 11;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;
  transition: background-color 0.12s ease, transform 0.08s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.06);
  }

  &:focus-visible {
    outline: 2px solid ${tokens.colors.basics[0]};
    outline-offset: -4px;
  }
`;
